import { defineStore } from 'pinia'

interface AppAddressStoreState {
	code: string | null
	latitude: number | null
	longitude: number | null
	text: string | null
}

export const useAppAddressStore = defineStore('appAddress', {
	state: (): AppAddressStoreState => ({
		code: null,
		latitude: null,
		longitude: null,
		text: null,
	}),
	actions: {
		setCode(code: string) {
			this.code = code
		},
		setLatitude(latitude: number) {
			this.latitude = latitude
		},
		setLongitude(longitude: number) {
			this.longitude = longitude
		},
		setText(text: string) {
			this.text = text
		},
	},
})
